/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable no-console */
import { Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import { UntypedFormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { fileDataTypesMapUI, PlatformName, PlatformProvider, sanitizePositionProperty } from '@shared';
import { Subscription } from 'rxjs';
import { FormControlTextbox } from '../../controls';
import { LastFieldInteractionService } from '../../services';

@Component({
	selector: 'app-numeric-input',
	templateUrl: './numeric-input.component.html',
	styleUrls: ['./numeric-input.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => NumericInputComponent),
			multi: true
		}
	]
})
export class NumericInputComponent implements ControlValueAccessor, OnInit, OnDestroy {
	@Input() public dynamicFormControl: FormControlTextbox;
	@Input() public form: UntypedFormGroup;
	@Input() public isDebounceApplied: boolean;
	public fieldValue: number | any;
	public fieldHasFocus: boolean;
	public lastFieldSubscription: Subscription;

	public constructor(
		private lastFieldInteractionService: LastFieldInteractionService,
		private platformProvider: PlatformProvider
	) {}

	public ngOnInit() {
		// todo: check if bug on iOS for numeric keyboard with decimals was fixed (comma separator)
		if (this.platformProvider.getPlatform() === PlatformName.IOS) {
			this.dynamicFormControl.type = fileDataTypesMapUI.CHAR;
		}
	
		this.fieldValue =
			this.dynamicFormControl.value !== undefined ? Number(this.dynamicFormControl.value) : undefined;
		this.lastFieldSubscription = this.lastFieldInteractionService.lastAccessField$.subscribe(
			(fieldId: string | null) => (this.fieldHasFocus = fieldId === this.dynamicFormControl.key)
		);
	}

	

	public writeValue(value: number): void {
		if (value) {
			this.fieldValue = value;
		}
	}

	public registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	public registerOnTouched(): void {}

	public updateFieldHasFocus(): void {
		this.lastFieldInteractionService.setFieldId(this.dynamicFormControl.key);
	}

	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	public togglePositiveNegative(_: any): void {
		this.fieldValue =
			Number(this.fieldValue) < 0
				? Math.abs(Number(this.fieldValue)).toString()
				: (Number(this.fieldValue) * -1).toString();
	}

	public fieldValueChanged(e: any): void {
		this.fieldValue = sanitizePositionProperty(e.detail.value, this.platformProvider.getPlatform());
		this.propagateChange(this.fieldValue);
	}

	public ngOnDestroy(): void {
		this.lastFieldSubscription.unsubscribe();
	}

	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	private propagateChange = (_: any) => {};
}
